import {Component, Input} from "@angular/core";
import {IApiPagingOutput} from "libraries/service/resources/IApiPagingOutput";
import {ProcessingResultsContainerContexts} from "../processing-result-container/processing-result-container.component";

import {Yii} from "libraries/interfaces/Yii";
import { IMinimalProcessing } from "app_sasha/shared/resources/processings/IMinimalProcessing";


@Component({
    selector: 'processing-list',
    template: `
        <div class="list e2e-list">
            <div class="list-row" *ngFor="let processing of processings; trackBy: getProcessingId">
                <processing [processing]="processing" [context]="context" class="e2e-info-home-hour"></processing>
            </div>
        </div>`,
    styles: [``],
})
export class ProcessingListComponent {
    @Input()
    public processings: IMinimalProcessing[];

    @Input()
    public recordset: IApiPagingOutput;

    @Input()
    public context : ProcessingResultsContainerContexts;

    public labels = {
        noResults: Yii.t('wui-sasha-js', 'Aucun résultat pour votre recherche'),
    };


    public getProcessingId(processing: IMinimalProcessing) {
        return processing.id;
    }

}